import { createBrowserLogger } from '@zealot/monitoring/browser';

const logger = createBrowserLogger('clipboard');

// gloss
export const copyToClipboard = async (text: string): Promise<boolean> => {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      logger.warn('Modern Clipboard API failed, trying fallback');
    }
  }

  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);

    if (successful) {
      return true;
    }

    throw new Error('execCommand copy failed');
  } catch (error) {
    logger.error(error instanceof Error ? error : new Error(String(error)), { context: 'all copy methods failed' });
    return false;
  }
};

// gloss
export const getClipboardData = (event: ClipboardEvent) => {
  const clipboardData = event.clipboardData;
  if (!clipboardData) {
    return { text: '', html: '', items: [] };
  }

  const text = clipboardData.getData?.('text/plain') || '';
  const html = clipboardData.getData?.('text/html') || '';
  const items = clipboardData.items ? Array.from(clipboardData.items) : [];

  return { text, html, items };
};
